import { render } from "./PersonasFooter.vue?vue&type=template&id=1c043495&scoped=true"
import script from "./PersonasFooter.vue?vue&type=script&lang=js"
export * from "./PersonasFooter.vue?vue&type=script&lang=js"

import "./PersonasFooter.vue?vue&type=style&index=0&id=1c043495&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c043495"]])

export default __exports__